import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient";
import { ITopic } from "../types/newshub/_topic";
import { PaginationResponse, ResponseData } from "../types/_public";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_topics = PATH_NEWSHUB_API + '/topics';

const topicApi = {
  Topics(params: any): Promise<AxiosResponse<ResponseData<ITopic[]> & PaginationResponse, any>> {
    const url = `${path_topics}`
    return api.get(url, params)
  },
  allTopics(params: any = {}): Promise<AxiosResponse<ResponseData<ITopic[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/topics`
    return api.get(url, params)
  },
  postTopic(dataForm: any): Promise<AxiosResponse<ResponseData<ITopic>, any>> {
    const url = `${path_topics}`;
    return api.post(url, dataForm)
  },
  putTopic(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ITopic>, any>> {
    const url = `${path_topics}/${id}`;
    return api.put(url, dataForm)
  },
  deleteTopic(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ITopic>, any>> {
    const url = `${path_topics}/${id}`;
    return api.delete(url, dataForm)
  },
}
export default topicApi
